import React, { useEffect, useRef } from "react";
import { FaSearch, FaPencilAlt, FaCircle } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { Dropdown, Row, Col } from "react-bootstrap";
import maleImg from "../../../images/CCImages/PhysicianImageMale.png";
import femaleImg from "../../../images/CCImages/PhysicianImageFemale.png";
import styles from "./PhysicianCard.module.scss";
import { FaTrashCan } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { getUserInfoDetailsByUserId } from "../../../store/slices/userSlice";
import { useSelector, useDispatch } from "react-redux";

const PhysicianCard = ({
  physician,
  handleEdit,
  handleDelete,
  addModal,
  handleSearch,
  searchValue,
  handleShowGlobalViewModal,
  activeTab,
  showStatus,
  setShowStatus,
  toggleStatus,
  handleUpdateStatus,
  handleAssociateModal,
  isLoading,
}) => {
  const navigate = useNavigate();

  const statusRef = useRef();

  const dispatch = useDispatch();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { userInfoDetails } = useSelector((state) => state.users);

  useEffect(() => {
    if (userInfo) {
      dispatch(
        getUserInfoDetailsByUserId({
          userId: userInfo?._id,
          token,
          userType: 7,
          applicationId: 2,
        }),
      );
    }
  }, [dispatch, userInfo, token]);
  const handleViewPhysician = (physician) => {
    sessionStorage.setItem("physicianUserId", physician);
    return navigate("/physicianDetails");
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (statusRef.current && !statusRef.current.contains(event.target)) {
      setShowStatus(false);
    }
  };

  const getModulePermission = (moduleTitle, modules) => {
    const module = modules.find(
      (module) =>
        module?.parentModule?.title.toLowerCase() === moduleTitle.toLowerCase(),
    );
    if (module) return module;

    for (const module of modules) {
      if (module?.childModules) {
        const childModule = module.childModules.find(
          (child) => child?.title.toLowerCase() === moduleTitle.toLowerCase(),
        );
        if (childModule) return childModule;

        if (childModule?.subChildModules) {
          const subChildModule = childModule.subChildModules.find(
            (subChild) =>
              subChild?.title.toLowerCase() === moduleTitle.toLowerCase(),
          );
          if (subChildModule) return subChildModule;
        }
      }
    }

    return null;
  };

  let path = window.location.pathname;
  path = path.split("/");

  const currentModuleTitle = path[path.length - 1];

  const currentModulePermission = getModulePermission(
    currentModuleTitle,
    userInfoDetails,
  );

  const canView = currentModulePermission?.canView;
  const canEdit = currentModulePermission?.canEdit;
  const canAdd = currentModulePermission?.canAdd;
  const canDelete = currentModulePermission?.canDelete;
  const canExport = currentModulePermission?.canExport;

  return (
    <>
      <Row>
        <div
          className={`form-head d-flex mb-3 mb-md-4 align-items-start ${styles["form-head"]}`}
        >
          {activeTab == 1 && canAdd && (
            <div className="me-4 d-none d-lg-block">
              <div
                className={`btn btn-primary btn-rounded ${styles["btn-rounded"]}`}
                onClick={() => addModal(true)}
              >
                + Add Doctor
              </div>
              <div
                className={`btn btn-primary btn-rounded ${styles["btn-rounded"]}`}
                onClick={() => handleAssociateModal(true)}
              >
                + Associate
              </div>
            </div>
          )}

          <div
            className={`input-group search-area ms-auto d-inline-flex me-3 ${styles["search-area"]}`}
          >
            <input
              type="text"
              className="form-control"
              placeholder="Search here"
              value={searchValue}
              onChange={handleSearch}
            />
            <div className="input-group-append">
              <button type="button" className="input-group-text">
                <FaSearch className="flaticon-381-search-2" />
              </button>
            </div>
          </div>
        </div>
        {isLoading ? (
        <div
          className="d-flex flex-column justify-content-center align-items-center w-100"
          style={{ height: "300px" }}
        >
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <p className="mb-0 fw-semibold text-primary">Loading data...</p>
        </div>
      ) :
        physician &&
          physician.map((physician, index) => (
            <Col xl={3} lg={4} md={6} sm={6} key={index} className="mb-4">
              <div
                className={`${styles["doctor-card"]} shadow-sm border-0 rounded`}
              >
                <div
                  onClick={() => {
                    if (activeTab == 2) return;
                    canView && handleViewPhysician(physician?.userId?._id);
                  }}
                  className="cursor-pointer"
                >
                  <div className={styles["doctor-card-img"]}>
                    <img
                      src={
                        physician?.userId?.gender === "Male"
                          ? maleImg
                          : femaleImg
                      }
                      alt={physician?.name}
                      className="img-fluid rounded-circle"
                    />
                  </div>
                  <div className={styles["doctor-card-body"]}>
                    <h6 className={styles["doctor-name"]}>
                      {physician?.userId?.name}
                    </h6>
                    <p className={styles["doctor-specialization"]}>
                      {physician?.specialization?.specialization}
                    </p>
                    <p className={styles["doctor-location"]}>
                      <FaLocationDot /> {physician?.userId?.city?.name}
                    </p>
                    <div
                      className={`d-flex align-items-center justify-content-center gap-1 ${styles["doctorStatus"]}`}
                      onClick={(e) => {
                        if (activeTab != 2) return;
                        toggleStatus(index);
                        e.stopPropagation();
                      }}
                    >
                      <FaCircle
                        className={
                          physician?.asociatedClinic[0]?.clinicStatus ===
                          "Accepted"
                            ? "text-success me-1"
                            : physician?.asociatedClinic[0]?.clinicStatus ===
                                "Requested"
                              ? "text-muted me-1"
                              : "text-danger me-1"
                        }
                      />
                      {physician?.asociatedClinic[0]?.clinicStatus}
                    </div>
                    <div className={styles.statusWrapper}>
                      {showStatus === index && (
                        <div className={styles.statusWrapper}>
                          {["Accepted", "Requested", "Rejected"].map(
                            (status) => (
                              <div
                                key={status}
                                className={styles.status}
                                onClick={(e) => {
                                  handleUpdateStatus(status, physician?._id);
                                }}
                                ref={statusRef}
                              >
                                <FaCircle
                                  size={15}
                                  className={`me-1 ${
                                    status === "Accepted"
                                      ? "text-success"
                                      : status === "Requested"
                                        ? "text-muted"
                                        : "text-danger"
                                  }`}
                                />
                                {status}
                              </div>
                            ),
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* Dropdown Menu */}
                {activeTab != 2 && (
                  <Dropdown
                    className={`${styles["doctor-card-menu"]} position-absolute`}
                  >
                    <Dropdown.Toggle
                      variant=""
                      as="div"
                      className="btn-link i-false"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                          stroke="#342E59"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {canEdit && (
                        <Dropdown.Item onClick={() => handleEdit(physician)}>
                          <FaPencilAlt
                            size={14}
                            className="me-1 text-primary"
                          />{" "}
                          Edit
                        </Dropdown.Item>
                      )}
                      {canDelete && (
                        <Dropdown.Item onClick={() => handleDelete(physician)}>
                          <FaTrashCan size={14} className="me-1 text-danger" />{" "}
                          Delete
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default PhysicianCard;
